import { Box } from '@mui/material';
import CommonEntityStats from './CommonEntityStats';

const EntityStatsAccordingToType = ({ editableEntityData, setEditableEntityData, artists, global_constant }) => {
    return (
        <Box sx={styles.containerStyleColumn_sx}>
            {editableEntityData?.type?.toLowerCase() === 'artist' && (
                <CommonEntityStats
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    type={editableEntityData?.metadata?.type?.toLowerCase()}
                    artistType={editableEntityData?.metadata?.type?.toLowerCase()}

                    /**Common*/
                    artists={artists}
                    genre={false}

                    artist={true}
                    movie={false}
                    song={false}
                    video={false}
                    reel={false}
                    influencers={false}
                />
            )}
            {editableEntityData?.type?.toLowerCase() === 'movie' && (
                <CommonEntityStats
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    type={editableEntityData?.metadata?.type?.toLowerCase()}
                    artistType={editableEntityData?.metadata?.type?.toLowerCase()}

                    /**Common*/
                    artists={artists}
                    genre={true}

                    artist={false}
                    movie={true}
                    song={false}
                    video={false}
                    reel={false}
                    influencers={false}
                />
            )}

            {editableEntityData?.type?.toLowerCase() === 'song' && (
                <CommonEntityStats
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    type={editableEntityData?.metadata?.type?.toLowerCase()}
                    artistType={editableEntityData?.metadata?.type?.toLowerCase()}

                    /**Common*/
                    artists={artists}
                    genre={true}

                    artist={false}
                    movie={false}
                    song={true}
                    video={false}
                    reel={false}
                    influencers={false}
                />
            )}

            {editableEntityData?.type?.toLowerCase() === 'reel' && (
                <CommonEntityStats
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    type={editableEntityData?.metadata?.type?.toLowerCase()}
                    artistType={editableEntityData?.metadata?.type?.toLowerCase()}

                    /**Common*/
                    artists={artists}
                    genre={true}

                    artist={false}
                    movie={false}
                    song={false}
                    video={false}
                    reel={true}
                    influencers={false}
                />
            )}

            {editableEntityData?.type?.toLowerCase() === 'video' && (
                <CommonEntityStats
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    type={editableEntityData?.metadata?.type?.toLowerCase()}
                    artistType={editableEntityData?.metadata?.type?.toLowerCase()}

                    /**Common*/
                    artists={artists}
                    genre={true}

                    artist={false}
                    movie={false}
                    song={false}
                    video={true}
                    reel={false}
                    influencers={false}
                />
            )}

            {editableEntityData?.type?.toLowerCase() === 'influencers' && (
                <CommonEntityStats
                    editableEntityData={editableEntityData}
                    setEditableEntityData={setEditableEntityData}
                    global_constant={global_constant}
                    type={editableEntityData?.metadata?.type?.toLowerCase()}
                    artistType={editableEntityData?.metadata?.type?.toLowerCase()}

                    /**Common*/
                    artists={artists}
                    genre={true}

                    artist={false}
                    movie={false}
                    song={false}
                    video={false}
                    reel={false}
                    influencers={true}
                />
            )}
        </Box>
    );
}

const styles = {
    containerStyleRow_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 2,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        m: 4
    },
    containerStyleColumn_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
}

export default EntityStatsAccordingToType;